/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InterviewBookingMessageStoreRequest,
	InterviewBookingMessageStoreResponse,
} from '../types/InterviewBookingMessageStore'

/**
 * POST /interview-scheduling/tokens/messages
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/InterviewBookingMessageController.php InterviewBookingMessageController::store
 */
export async function interviewBookingMessageStore(
	data: InterviewBookingMessageStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InterviewBookingMessageStoreResponse>> {
	return axiosInstance.post('/interview-scheduling/tokens/messages', data, config)
}
